import React, { Component } from "react";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { alert } from '../../../../../common/Utils'
import { API_URL, ERROR_HANDLE, GYM_TAG_UNIQUE_ID } from "config/constants";
import GymList from '../../GymList';
import theme from '../../../../../Theme/theme'
import AmenitiesAddModal from "../../SingleGym/Amenities/AmenitiesAddModal";
import AmenityBox from "../../SingleGym/Amenities/AmenityBox";

const CREATE_TEXT = "Create"
const UPDATE_TEXT = "Update"
const GYM_TAG_NAME_TEXT = "Gym Tag Name"
const DESCRIPTION_TEXT = "Description"
const PRIMARY_AMENITY_TEXT = "Primary Amenity"
const ALERT_TEXT = "Name is mandatory. Please fill mandatory field"
const GYM_TAGS = "Gym Tags"
const LEFT_ARROW_IMAGE = require('../../../../../assets/images/left-arrow-black.png');

class CreateGymTag extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            gymTagId: null,
            name: "",
            description: "",
            gymsList: [],
            gymsSelected: [],
            selectedPrimaryAmenity: [],
            selectedPrimaryAmenityId: []
        };
        this.allPrimaryAmenities = [];
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.gymTagId) {
            this.getGymTag(this.props.location.state.gymTagId)
        }
    }

    getGymTag(gymTagId) {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Fetching Gym Tag...");
        axios
            .get(`${API_URL}/tags/${gymTagId}`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                const gymTag = res.data;
                this.setState({
                    gymTagId: gymTag.id,
                    name: gymTag.name,
                    description: gymTag.description,
                    gymsSelected: gymTag.gyms_selected,
                    selectedPrimaryAmenity: gymTag.selected_primary_amenity
                }, () => { this._gymListRef && this._gymListRef.updateSelectedGymList() })
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
    }

    getPrimaryAmenities() {
        const access_token = localStorage.getItem("access_token");
        axios
            .get(`${API_URL}/gyms/amenities/icons/primaryAmenities`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                const primary_amenities = res.data;
                this.allPrimaryAmenities = primary_amenities;
                this.setState({ modal: true });
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    updateGymTag(gymTagId) {
        const {
            name,
            description
        } = this.state;
        const toastId = toast("Updating Gym Tag...");
        const access_token = localStorage.getItem("access_token");
        const gymsSelectedList = this.getSelectedGyms();
        axios
            .put(
                `${API_URL}/tags/${gymTagId}`,
                {
                    name,
                    description,
                    gyms_selected: gymsSelectedList.gyms.length === 0 ? [] : gymsSelectedList.gyms,
                    tags_selected: gymsSelectedList.gymTags.length === 0 ? [] : gymsSelectedList.gymTags,
                    primary_amenity: this.state.selectedPrimaryAmenityId
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(res => {
                toast.dismiss(toastId);
                toast("Updated Successfully", { autoClose: 1500 });
                this.props.history.push('/gyms/GymTags/')
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
    }

    createGymTag() {
        const {
            name,
            description
        } = this.state;
        const toastId = toast("Creating Gym Tag...");
        const access_token = localStorage.getItem("access_token");
        const gymsSelectedList = this.getSelectedGyms();
        axios
            .post(
                `${API_URL}/tags`,
                {
                    name,
                    description,
                    gyms_selected: gymsSelectedList.gyms.length === 0 ? [] : gymsSelectedList.gyms,
                    tags_selected: gymsSelectedList.gymTags.length === 0 ? [] : gymsSelectedList.gymTags,
                    primary_amenity: this.state.selectedPrimaryAmenityId
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(res => {
                toast.dismiss(toastId);
                toast("Created Successfully", { autoClose: 1500 });
                this.props.history.push('/gyms/GymTags/')
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
    }

    renderPrimaryAmenities = () => {
        const classAmenities = this.state.selectedPrimaryAmenity.map((currentItem, index, arr) => {
            const classid = currentItem.id;
            this.state.selectedPrimaryAmenityId.push(classid);
            return (<div style={{ margin: "10px" }}>
                <AmenityBox
                    edit
                    label={currentItem.name}
                    source={currentItem.icons.black}
                    onXClick={() => {
                        this.setState({ selectedPrimaryAmenity: [], selectedPrimaryAmenityId: [] });
                    }}
                />
            </div>
            );
        });
        const showAddButton = this.state.selectedPrimaryAmenity.length > 0 ? false : true
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "grid" }}>
                    {classAmenities}
                    {showAddButton && <AmenityBox
                        label={"Add Item"}
                        onClick={() => {
                            this.getPrimaryAmenities()
                        }}
                    />}
                </div>
            </div>
        );
    };

    getSelectedGyms() {
        let gyms = []
        let gymTags = []
        this.state.gymsSelected.map((gym) => {
            gym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? gymTags.push(parseInt(gym.gym_id)) : gyms.push(parseInt(gym.gym_id))
        })
        return { gyms, gymTags }
    }

    /**
     * @description this is the props method gets handled from gym list component to avoid gyms API call every time.
     * @param gymsList - the gymsList value will receive from gym list component
     */
    updateGymsList = (gymsList) => {
        this.setState({
            gymsList
        })
    }

    /**
     * @description this is the props method gets handled from gym list component to update selected gyms.
     * @param gymsList - the selected gymsList value will receive from gym list component
     */
    updateSelectedGyms = (gymsSelected) => {
        this.setState({
            gymsSelected
        })
    }

    isMandatoryFieldsEntered() {
        return this.state.name.length > 0 ? true : false
    }

    render() {
        return (
            <div style={style.wrapper}>
                <Box style={style.box} outline>
                    {this.state.modal && (
                        <AmenitiesAddModal
                            isPrimaryAmenity={true}
                            data={this.allPrimaryAmenities[0].amenities}
                            add={(amenityId) => {
                                this.allPrimaryAmenities[0].amenities.forEach(amenity => {
                                    if (amenity.id == amenityId) this.setState({ selectedPrimaryAmenity: [amenity], modal: false })
                                })
                            }}
                        />
                    )}
                    <Link style={style.linkStyle} to="/gyms/GymTags/">
                        <img style={{ width: 40, height: 40 }} src={LEFT_ARROW_IMAGE} />
                        <Button
                            style={style.gymTags}
                            type="primary"
                        >
                            {GYM_TAGS}
                        </Button>
                    </Link>
                    <div style={style.topPanel}>
                        <div>
                            <div style={style.selectorWrapper}>
                                <p style={style.selectorLabel}>
                                    {GYM_TAG_NAME_TEXT} &nbsp; &nbsp;
                                </p>
                                <input
                                    type="text"
                                    value={this.state.name}
                                    style={style.input}
                                    onChange={e => {
                                        this.setState({
                                            name: e.target.value
                                        });
                                    }}
                                />
                            </div>
                            <div style={style.selectorWrapper}>
                                <p style={style.selectorLabel}>
                                    {DESCRIPTION_TEXT} &nbsp; &nbsp;
                                </p>
                                <input
                                    type="text"
                                    value={this.state.description}
                                    style={style.input}
                                    onChange={e => {
                                        this.setState({
                                            description: e.target.value
                                        });
                                    }}
                                />
                            </div>
                            <div style={{...style.selectorWrapper, ...{justifyContent: "flex-start"}}}>
                                <p style={style.selectorLabel}>
                                    {PRIMARY_AMENITY_TEXT} &nbsp; &nbsp;
                                </p>
                                {this.renderPrimaryAmenities()}
                            </div>
                        </div>
                        <GymList
                            ref={gymListRef => this._gymListRef = gymListRef}
                            gymsList={this.state.gymsList}
                            gymsSelected={this.state.gymsSelected ? this.state.gymsSelected : []}
                            updateGymsList={(gymsList) => this.updateGymsList(gymsList)}
                            updateSelectedGyms={(gymsSelected) => this.updateSelectedGyms(gymsSelected)}
                            showGymTag={false}
                        />
                    </div>
                    <div style={style.createButtonWrapper}>
                        <Button
                            style={style.createButton}
                            type="primary"
                            onClick={() => this.isMandatoryFieldsEntered() ? (this.props.location.state && this.props.location.state.gymTagId) ? this.state.gymTagId && this.updateGymTag(this.state.gymTagId) : this.createGymTag() : alert(ALERT_TEXT)}
                        >
                            {(this.props.location.state && this.props.location.state.gymTagId) ? UPDATE_TEXT : CREATE_TEXT}
                        </Button>
                    </div>
                </Box>
            </div>
        );
    }
}

const style = {
    wrapper: {
        display: "flex",
        justifyContent: "center",
        margin: "30px 30px 0px 30px",
        paddingBottom: 50
    },
    box: {
        width: "1200px",
        display: "flex",
        flexDirection: "column",
        padding: "40px"
    },
    topPanel: {
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center"
    },
    createButtonWrapper: {
        width: "100%",
        justifyContent: "flex-start",
        marginTop: 20
    },
    createButton: {
        width: "300px",
        fontSize: "20px",
        marginTop: "20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 100
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "160px",
        textAlign: "left"
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: "22px",
        color: "#00b4d2",
        padding: 10,
        paddingLeft: 20,
        minWidth: 300,
        textAlign: "left"
    },
    gymTags: {
        width: 200,
        fontSize: 17,
        borderRadius: 8,
        height: 40,
        color: theme.color.primaryBlue,
        backgroundColor: theme.color.white,
        borderWidth: 0,
        textAlign: "left"
    },
    linkStyle: {
        display: "flex",
        height: 40,
        textDecoration: "none"
    }
};

export default CreateGymTag;
